export default __webpack_public_path__ + "static/media/fleetSolo2.f4b96715.png";